module.exports = __webpack_public_path__ + "media/assets/images/landing/logo_about_2-90b07126919878e5b33edc2ee211e091.png";